import React, { useState } from 'react';
import HeaderLP from '../components/LandingPageSections/HeaderLP';
import HeroSection from '../components/LandingPageSections/HeroSection';
import {
  AudiencePathsSection,
  BuildTogetherSection,
  CoCreationSection,
  FinalInviteSection,
  TrustSecuritySection,
} from '../components/LandingPageSections/LandingNarrativeSections';
import FooterLP from '../components/LandingPageSections/FooterLP';
import { Button } from '../components/common/UIComponents';

const PublicBuildNoticeModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/75 px-4 py-5 backdrop-blur-[4px]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="public-build-notice-title"
    >
      <div className="w-full max-w-[420px] rounded-lg border border-primary-dark-300 bg-primary-dark-200 p-5 shadow-[0_24px_80px_rgba(0,0,0,0.62)] sm:p-6">
        <div className="space-y-3">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-ratuj-200">
            Informacja
          </p>
          <h2
            id="public-build-notice-title"
            className="text-lg font-semibold leading-snug text-primary-light-100 sm:text-xl"
          >
            Ratuj Sprzęt jest jeszcze w budowie
          </h2>
          <p className="text-sm leading-6 text-primary-light-300">
            Możesz już przeglądać serwisy i testować główne funkcje, ale część widoków i danych może
            się jeszcze zmieniać. Pracujemy nad dopracowaniem platformy.
          </p>
        </div>

        <Button type="button" onClick={onClose} fullWidth className="mt-5">
          Rozumiem
        </Button>
      </div>
    </div>
  );
};

const LandingPage = () => {
  const [isBuildNoticeVisible, setIsBuildNoticeVisible] = useState(true);

  return (
    <div className="min-h-screen bg-primary-dark-100 text-primary-light-100">
      <HeaderLP />
      <main>
        <HeroSection />
        <BuildTogetherSection id="jak-budujemy" />
        <TrustSecuritySection />
        <AudiencePathsSection />
        <CoCreationSection id="wspoltworzenie" />
        <FinalInviteSection id="kontakt" />
      </main>
      <FooterLP />
      {isBuildNoticeVisible && (
        <PublicBuildNoticeModal onClose={() => setIsBuildNoticeVisible(false)} />
      )}
    </div>
  );
};

export default LandingPage;
